import React from "react";
import { Row, Column, FormGroup, Checkbox } from "carbon-components-react";
import useGet from "../../hooks/useGet";
import DynamicCheckbox from "../Checkboxes/DynamicCheckbox";
import {
  isCandidatureOptionChecked,
  updateCheckedOptions,
} from "../../services/Utils";
import { useEffect } from "react";

const WorkAreaForm = ({
  disabled,
  candidature,
  selectedWorkAreas,
  setSelectedWorkAreas,
}) => {
  const { data: workAreas } = useGet("/lookup/work-areas");

  const updateWorkAreas = (id, checked) => {
    setSelectedWorkAreas(updateCheckedOptions(selectedWorkAreas, id, checked));
  };

  return (
    <FormGroup legendText="ÁREA DE TRABALHO" className="section-header">
      {selectedWorkAreas && (
        <fieldset className="bx--fieldset">
          <legend className="bx--label">17. Em que área trabalhas?</legend>
          <p>Listar a(s) área(s):</p>

          <Row>
            <Column sm={12} md={12} lg={12}>
              {workAreas.map((x) => (
                <DynamicCheckbox
                  key={"wa" + x.id}
                  id={x.id}
                  disabled={disabled}
                  label={x.description}
                  updateItems={updateWorkAreas}
                  checked={isCandidatureOptionChecked(selectedWorkAreas, x.id)}
                />
              ))}
            </Column>
          </Row>
        </fieldset>
      )}
    </FormGroup>
  );
};

WorkAreaForm.defaultProps = {
  disabled: false,
};

export default WorkAreaForm;
